import { type Components, type Theme } from "@mui/material/styles";

export const toggleButton: Components<Theme>["MuiToggleButton"] = {
  defaultProps: {
    size: "small",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      ...theme.typography.body3,
      textTransform: "none",
      color: theme.palette.text.secondary,
      border: 0,
      borderRadius: theme.shape.borderRadius,
      gap: theme.spacing(0.75),
      "&:hover": {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.action.hover,
      },
      "&.Mui-selected": {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.default,
        boxShadow: theme.shadows[1],
        "&:hover": {
          backgroundColor: theme.palette.background.default,
        },
      },
      "&.Mui-disabled": {
        border: 0,
        opacity: 0.5,
      },
    }),
  },
};
